<template>
    <div class="popup" v-if="value">
        <div class="content" :style="{height: height}">
            <slot>
                <div class="text-wrapper">
                    <div class="text">
                        <div class="station">{{name}}</div>
                        <div class="cost">
                            <div class="cost-name">{{$t('duration')}}:&nbsp;</div>
                            <div class="cost-time">{{duration}}</div>
                        </div>
                    </div>
                    <div class="img">
                        <img :src="src" height="280" width="420" />
                    </div>
                </div>
            </slot>
            <div class="btn-wrapper">
                <button class="pop-btn pop-btn-start" @click="start">{{text}}</button>
                <button class="pop-btn pop-btn-cancel" @click="cancel">{{$t('cancel')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Popup",

    model: {
        prop: "value",
        event: "change"
    },

    props: {
        value: {
            type: Boolean
        },
        height: {
            type: String,
            default: "55%"
        },
        name: {
            type: String
        },
        src: {
            type: String
        },
        duration: {
            type: String
        },
        text: {
            type: String
        }
    },

    methods: {
        start() {
            this.$emit("change", false);
            this.$emit("onConfirm");
        },

        cancel() {
            this.$emit("change", false);
        }
    }
};
</script>

<style scoped>
.popup {
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
}

.content {
    width: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 16px;
    padding: 60px 30px;
    display: flex;
    flex-direction: column;
}

.text-wrapper {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: row;
}

.text,
.img {
    width: 50%;
    flex: 1;
}

.station {
    padding-right: 10px;
    font-family: PingFang-SC-Bold;
    font-size: 40px;
    color: #1c1c1c;
    letter-spacing: 0;
    line-height: 60px;
}

.cost {
    padding: 10px 0;
    display: flex;
    align-items: center;
}

.cost-name {
    font-family: PingFang-SC-Medium;
    font-size: 32px;
    color: #80848f;
    line-height: 40px;
    white-space: nowrap;
}

.cost-time {
    font-family: PingFang-SC-Medium;
    font-size: 32px;
    color: #1c1c1c;
    line-height: 50px;
    text-align: center;
    padding-right: 10px;
}

.img {
    height: 280px;
    width: 420px;
}

.btn-wrapper {
    height: 80px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
}

.pop-btn {
    height: 80px;
    width: 380px;
    border-radius: 40px;
    font-family: PingFang-SC-Medium;
    font-size: 36px;
    border: none;
}

.pop-btn-start {
    background: #413cf9;
    color: #fff;
}

.pop-btn-cancel {
    background: #d7dce7;
    color: #484848;
}
</style>